import { styled, Box } from "@mui/material";

const Flexbetween = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export default Flexbetween;